import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BattleSelection.css';

const BattleSelection = () => {
    const navigate = useNavigate();
    const [userInput, setUserInput] = useState('');

    // Debug logging and storage setup
    useEffect(() => {
        console.log('BattleSelection initialized');
        // Clear any previous battle data when starting fresh
        sessionStorage.removeItem('currentBattleCode');
        sessionStorage.removeItem('battleCompleteData');
        sessionStorage.removeItem('battleWorkoutProgress');
    }, []);

    // Battle workout presets (from your Android GameSelectionScreen)
    const battleWorkouts = [
        { code: "lsit", name: "leg shoulder bicep tricep Workout" },
        { code: "cbolt", name: "chest back core leg tricep Workout" },
        { code: "boldrun", name: "back core leg core arm glute hamstring Workout" },
        { code: "onlyfit", name: "core hamstring leg thigh forearm bicep tricep Workout" },
        { code: "rich+", name: "arm bicep chest shoulder abs Workout" },
        { code: "sold+", name: "shoulder core leg core abs Workout" },
        { code: "exgym$", name: "chest back leg thigh arm chest Workout" },
        { code: "kickit@", name: "back bicep chest back bicep tricep back Workout" },
        { code: "holdthat:", name: "shoulder core leg core tricep shoulder abs tricep trap Workout" },
        { code: "mustgo@", name: "arm glute shoulder tricep leg core back Workout" },
        { code: "inside", name: "bicep hamstring shoulder bicep core chest Workout" },
        { code: "tuffdude^", name: "tricep glute forearm forearm core glute chest arm Workout" },
        { code: "fight@", name: "forearm bicep leg shoulder tricep back Workout" },
        { code: "getshreded", name: "leg chest tricep shoulder shoulder arm chest core chest core Workout" },
        { code: "allthe$", name: "abs leg leg tricep shoulder chest chest Workout" },
        { code: "verycool:", name: "calves chest arm thigh chest core core leg Workout" },
        { code: "pillfit$", name: "trap bicep leg leg forearm bicep tricep chest Workout" },
        { code: "quick}", name: "quad glute bicep chest back calve Workout" },
        { code: "nocode[]", name: "hamstring core chest core core chest quad hamstring Workout" },
        { code: "useeit()", name: "glute shoulder chest chest bicep tricep Workout" },
        { code: "justsweat!", name: "hip glute shoulder tricep shoulder chest chest abs tricep overall Workout" },
        { code: "youare&", name: "thigh core glute abs arm chest shoulder Workout" },
        { code: "zipline$&", name: "oblique bicep trap leg bicep hamstring chest chest shoulder Workout" },
        { code: "!*()", name: "overall arm bicep tricep shoulder Workout" },
        { code: "gohot$", name: "leg core shoulder core tricep chest Workout" },
        { code: "x^&roll", name: "back arm shoulder arm core leg leg Workout" },
        { code: "&[][]", name: "shoulder quad hamstring quad hamstring Workout" },
        { code: "**&**", name: "arm arm shoulder arm arm Workout" },
        { code: "(fit}", name: "bicep forearm bicep tricep calve Workout" },
        { code: ")getinshape(", name: "tricep leg chest tricep bicep hamstring shoulder shoulder abs trap chest Workout" },
        { code: "-addthemath", name: "forearm abs core core tricep shoulder chest arm abs tricep shoulder Workout" },
        { code: "+minusyou", name: "abs arm bicep hamstring glute shoulder thigh core glute Workout" },
        { code: "=theway!", name: "legs tricep shoulder chest chest abs thigh overall Workout" },
        { code: "[][]heavy", name: "quad hamstring quad hamstring shoulder chest arm calves thigh Workout" },
        { code: "]liftbig[", name: "hamstring leg bicep forearm tricep back bicep leg quad Workout" },
        { code: "{crushit}", name: "glute chest arm glute shoulder shoulder bicep tricep calve Workout" },
        { code: "}dontslip{", name: "calve core core hamstring tricep shoulder leg bicep trap glute Workout" },
        { code: ":keeppace:", name: "trap back chest chest trap trap abs chest chest trap Workout" },
        { code: ";notrow", name: "oblique hamstring core tricep arm core chest Workout" },
        { code: "|inside", name: "hip bicep hamstring shoulder bicep core chest Workout" },
        { code: "<cco>", name: "thigh chest chest core overall Workout" },
        { code: "><><><", name: "overall thigh overall thigh overall thigh Workout" },
        { code: "~snake~", name: "leg shoulder hamstring abs back chest leg Workout" },
        { code: "lost", name: "leg core shoulder tricep Workout" },
        { code: "@funfit", name: "back forearm glute hamstring forearm bicep tricep Workout" },
        { code: "dice$", name: "core tricep chest chest chest Workout" },
        { code: "^uknowit!", name: "arm glute back hamstring core chest bicep tricep overall Workout" },
        { code: "_gofast", name: "shoulder leg core forearm abs shoulder tricep Workout" }
    ];

    // Muscle groups mapping (from your Android app)
    const muscleGroups = [
        { name: "legband", code: "l" }, { name: "chestband", code: "c" }, { name: "backband", code: "b" },
        { name: "coreband", code: "o" }, { name: "armband", code: "r" }, { name: "shoulderband", code: "s" },
        { name: "chest", code: "e" }, { name: "back", code: "k" }, { name: "shoulder", code: "h" },
        { name: "arm", code: "m" }, { name: "bicep", code: "i" }, { name: "tricep", code: "t" },
        { name: "forearm", code: "f" }, { name: "legs", code: "g" }, { name: "abs", code: "a" },
        { name: "calves", code: "v" }, { name: "trap", code: "p" }, { name: "quad", code: "q" },
        { name: "hamstring", code: "n" }, { name: "glute", code: "u" }, { name: "hip", code: "j" },
        { name: "thigh", code: "y" }, { name: "oblique", code: "z" }, { name: "overall", code: "!" },
        { name: "chestgym", code: "$" }, { name: "backgym", code: "x" }, { name: "shouldergym", code: "&" },
        { name: "armgym", code: "*" }, { name: "bicepgym", code: "(" }, { name: "tricepgym", code: ")" },
        { name: "forearmgym", code: "-" }, { name: "abgym", code: "+" }, { name: "leggym", code: "=" },
        { name: "quadgym", code: "[" }, { name: "hamgym", code: "]" }, { name: "glutegym", code: "{" },
        { name: "calvegym", code: "}" }, { name: "trapgym", code: ":" }, { name: "obliquegym", code: ";" },
        { name: "hipgym", code: "|" }, { name: "thighgym", code: "<" }, { name: "overallgym", code: ">" },
        { name: "legbody", code: "~" }, { name: "chestbody", code: "w" }, { name: "backbody", code: "@" },
        { name: "corebody", code: "d" }, { name: "armbody", code: "^" }, { name: "shoulderbody", code: "_" }
    ];

    const allowedChars = "lcborsekhitfgavpqnujyz!$x&*()-+=[]{}:;|<>~w@d^_";

    // Handle adding character to input
    const addCharacter = (char) => {
        const newInput = userInput + char;
        const lastThreeChars = newInput.slice(-3);

        // Prevent three consecutive same characters
        if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
            setUserInput(newInput);

            // Save to storage immediately for persistence
            const updatedInput = newInput;
            sessionStorage.setItem('currentBattleCode', updatedInput);
            localStorage.setItem('lastBattleCode', updatedInput);

            console.log('Battle code updated:', updatedInput);
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        const input = e.target.value.toLowerCase();
        const validInput = input.split('').filter(char => allowedChars.includes(char)).join('');

        // Check for three consecutive same characters
        let result = '';
        for (let i = 0; i < validInput.length; i++) {
            const char = validInput[i];
            const lastThreeChars = result.slice(-2) + char;
            if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
                result += char;
            }
        }

        setUserInput(result);

        // Save to storage immediately
        sessionStorage.setItem('currentBattleCode', result);
        localStorage.setItem('lastBattleCode', result);

        console.log('Battle code updated via input:', result);
    };

    // Handle preset workout selection
    const handlePresetSelect = (workoutCode) => {
        setUserInput(workoutCode);

        // Save to storage immediately
        sessionStorage.setItem('currentBattleCode', workoutCode);
        localStorage.setItem('lastBattleCode', workoutCode);

        console.log('Preset battle code selected:', workoutCode);
    };

    // Clear battle code
    const handleClearCode = () => {
        setUserInput('');
        sessionStorage.removeItem('currentBattleCode');
        console.log('Battle code cleared');
    };

    // Handle next button with enhanced storage and validation
    const handleNext = () => {
        if (userInput.trim() !== '') {
            const battleCode = userInput.trim();

            console.log('BattleSelection - Navigating with battle code:', battleCode);

            // TRIPLE STORAGE: Save battle code in multiple places
            // 1. Session storage with multiple keys
            sessionStorage.setItem('currentBattleCode', battleCode);
            sessionStorage.setItem('selectedBattleCode', battleCode);

            // 2. Local storage for persistence
            localStorage.setItem('lastBattleCode', battleCode);
            localStorage.setItem('currentBattleSelection', battleCode);

            // 3. Prepare navigation data
            const navData = {
                battleCode: battleCode,
                workoutType: 'battle',
                timestamp: new Date().toISOString()
            };

            // 4. Save complete navigation data
            sessionStorage.setItem('battleNavData', JSON.stringify(navData));

            // Navigate with properly encoded workout code TO BATTLE REP COUNT
            const encodedWorkoutCode = encodeURIComponent(battleCode);

            console.log('Encoded battle code for URL:', encodedWorkoutCode);
            console.log('Navigation state:', navData);

            navigate(`/battle-rep-count/${encodedWorkoutCode}`, {
                state: navData
            });
        } else {
            alert('Please enter a battle code or select a preset workout!');
        }
    };

    // Generate random background image
    const getRandomBackground = () => {
        const randomIndex = Math.floor(Math.random() * 88) + 1;
        return `url(/assets/images/v${randomIndex}.jpg)`;
    };

    // Load any existing battle code on mount
    useEffect(() => {
        const existingCode = sessionStorage.getItem('currentBattleCode') || localStorage.getItem('lastBattleCode');
        if (existingCode && existingCode !== 'undefined') {
            setUserInput(existingCode);
            console.log('Loaded existing battle code:', existingCode);
        }
    }, []);

    return (
        <div
            className="battle-selection-container"
            style={{
                backgroundImage: getRandomBackground(),
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            {/* Dark overlay */}
            <div className="battle-overlay"></div>

            {/* Fixed top bar */}
            <div className="battle-top-bar">
                <button
                    className="battle-back-button"
                    onClick={() => navigate('/')}
                >
                    ← Back
                </button>

                <div className="battle-input-section">
                    <input
                        type="text"
                        className="battle-input"
                        value={userInput}
                        onChange={handleInputChange}
                        placeholder="Enter battle code..."
                        maxLength={20}
                    />

                    {userInput && (
                        <button
                            className="battle-clear-button"
                            onClick={handleClearCode}
                            title="Clear battle code"
                        >
                            ✕
                        </button>
                    )}
                </div>

                <button
                    className="battle-next-button"
                    onClick={handleNext}
                    disabled={userInput.trim() === ''}
                >
                    Next ⚔️
                </button>
            </div>

            {/* Scrollable content */}
            <div className="battle-content">
                <div className="battle-header">
                    <h1>⚔️ BATTLE MODE ⚔️</h1>
                    <p>Choose your battle combination to face the villains!</p>

                    {userInput && (
                        <div className="current-battle-code">
                            <strong>Current Battle Code: </strong>
                            <span className="battle-code-display">{userInput}</span>
                            <span className="battle-code-length">({userInput.length} characters)</span>
                        </div>
                    )}
                </div>

                {/* Muscle group buttons */}
                <div className="muscle-groups-section">
                    <h3>💪 Muscle Groups</h3>
                    <div className="muscle-groups-grid">
                        {muscleGroups.map((group) => (
                            <button
                                key={group.code}
                                className="muscle-group-button"
                                onClick={() => addCharacter(group.code)}
                            >
                                <span className="muscle-code">{group.code}</span>
                                <span className="muscle-name">{group.name}</span>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Character selector */}
                <div className="character-selector">
                    <h3>⚡ Quick Character Input:</h3>
                    <div className="character-grid">
                        {allowedChars.split('').map((char) => (
                            <button
                                key={char}
                                className="character-button"
                                onClick={() => addCharacter(char)}
                            >
                                {char}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Preset battle workouts */}
                <div className="preset-workouts">
                    <h3>⚡ Epic Battle Presets ⚡</h3>
                    <div className="preset-workouts-grid">
                        {battleWorkouts.map((workout) => (
                            <div
                                key={workout.code}
                                className={`preset-workout-card ${userInput === workout.code ? 'selected' : ''}`}
                                onClick={() => handlePresetSelect(workout.code)}
                            >
                                <div className="preset-code">{workout.code}</div>
                                <div className="preset-name">{workout.name}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="battle-instructions">
                    <p>💀 Face villains in epic workout battles!</p>
                    <p>⚔️ Each character summons different muscle groups and villains</p>
                    <p>🏆 Your past workout history strengthens you with Hidden Health Bonus!</p>
                    <p>🔥 Battle codes are saved automatically for easy access</p>
                </div>
            </div>
        </div>
    );
};

export default BattleSelection;